// extracted by mini-css-extract-plugin
export default {"videoWrapper":"VideoAnimation_videoWrapper","visible":"VideoAnimation_visible"};